export default __webpack_public_path__ + "static/media/trafficlightcolour.5e9ad71f.png";